import React, { useContext } from "react";
import { Box, IconButton, Stack } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import { FaTiktok } from "react-icons/fa6"; // ← Import TikTok
import { AuthContext } from "../../../context/authContext";

const ContactFlotanteDiv = () => {
  const { empresa = {} } = useContext(AuthContext);

  const whatsappURL = empresa?.telefonos_sitio
    ? `https://wa.me/${empresa.telefonos_sitio}`
    : "https://wa.me/549999999999";

  const facebookURL = empresa?.emp_facebook
    ? `https://${empresa.emp_facebook}`
    : "https://facebook.com";

  const instagramURL = empresa?.emp_instagram
    ? `https://${empresa.emp_instagram}`
    : "https://instagram.com";

  const tiktokURL = empresa?.emp_tiktok
    ? `https://${empresa.emp_tiktok}`
    : "https://www.tiktok.com";

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 100,
        right: 20,
        zIndex: 1000,
      }}
    >
      <Stack spacing={1} alignItems="flex-end">
        {/* WhatsApp */}
        <IconButton
          href={whatsappURL}
          target="_blank"
          sx={{
            bgcolor: "#25D366",
            color: "#fff",
            width: 56,
            height: 56,
            borderRadius: "50%",
            boxShadow: 3,
            "&:hover": { bgcolor: "#1ebe57" },
          }}
        >
          <WhatsAppIcon sx={{ fontSize: 36 }} />
        </IconButton>

        {/* Facebook */}
        {empresa?.emp_facebook && (
          <IconButton
            href={facebookURL}
            target="_blank"
            sx={{
              bgcolor: "#3b5998",
              color: "#fff",
              width: 56,
              height: 56,
              borderRadius: "50%",
              boxShadow: 3,
              "&:hover": { bgcolor: "#2d4373" },
            }}
          >
            <FacebookIcon sx={{ fontSize: 36 }} />
          </IconButton>
        )}

        {/* Instagram */}
        {empresa?.emp_instagram && (
          <IconButton
            href={instagramURL}
            target="_blank"
            sx={{
              bgcolor: "#E1306C",
              color: "#fff",
              width: 56,
              height: 56,
              borderRadius: "50%",
              boxShadow: 3,
              "&:hover": { bgcolor: "#c2185b" },
            }}
          >
            <InstagramIcon sx={{ fontSize: 36 }} />
          </IconButton>
        )}

        {/* TikTok */}
        {empresa?.emp_tiktok && (
          <IconButton
            href={tiktokURL}
            target="_blank"
            sx={{
              bgcolor: "#000",
              color: "#fff",
              width: 56,
              height: 56,
              borderRadius: "50%",
              boxShadow: 3,
              "&:hover": { bgcolor: "#222" },
            }}
          >
            <FaTiktok size={28} />
          </IconButton>
        )}
      </Stack>
    </Box>
  );
};

export default ContactFlotanteDiv;
